import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import HomeIconExit from 'components/HomeExitIcon';
import LoadingIndicator from 'components/LoadingIndicator';
import { errorShape } from 'utils/shapes';
import './TheoData.css';

function TheoData({ link, linkAlt, data, onClick }) {
  const { loading, error } = data;
  if (loading) {
    return <LoadingIndicator size={30} />;
  }

  if (error) {
    return <span>There was an error retrieving NetTheo.</span>;
  }

  const linkToProfile = (
    <a href={link} rel="noopener noreferrer" aria-label={linkAlt || undefined}>
      Click here for more details
    </a>
  );

  const { patronAccountNumber, name, location, theo, rate } =
    data.theoPopUpData;
  return (
    <div className="theo-data">
      <div>{`CMP: ${patronAccountNumber || 'N/A'}`}</div>
      <div>{`Name: ${name || 'N/A'}`}</div>
      <div>{`State: ${location || 'N/A'}`}</div>
      <div>{`NetTheo (118d): ${'$' + (theo || '0')}`}</div>
      <div>{`Reinvestment Rate (118d): ${
        ((rate * 100).toFixed(2) || 0) + '%'
      }`}</div>
      {linkToProfile}
      <HomeIconExit className="theo-exit-icon" onClick={onClick} />
    </div>
  );
}

TheoData.propTypes = {
  userId: PropTypes.string,
  link: PropTypes.string,
  linkAlt: PropTypes.string,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: errorShape,
    theoPopUpData: PropTypes.shape({
      patronAccountNumber: PropTypes.string,
      name: PropTypes.string,
      location: PropTypes.string,
      theo: PropTypes.number,
      rate: PropTypes.number
    })
  })
};

const QUERY_GET_THEOPOPUPDATA = gql`
  query theoPopUpData($input: GetTheoPopUpData!) {
    theoPopUpData(input: $input) {
      patronAccountNumber
      name
      location
      theo
      rate
    }
  }
`;

export default graphql(QUERY_GET_THEOPOPUPDATA, {
  options: props => ({
    variables: {
      input: {
        userId: props.userId
      }
    }
  })
})(TheoData);
